import LegalLayout from "@/components/feature/LegalLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-4 py-3 border-b border-background-200 last:border-b-0">
      <dt className="sm:w-56 shrink-0 text-sm font-medium text-foreground-500">
        {label}
      </dt>
      <dd className="text-sm text-foreground-900">{value}</dd>
    </div>
  );
}

export default function MentionsLegales() {
  usePageMeta(
    "Mentions légales | Mobicar Pro",
    "Informations légales de Mobicar Pro : SASU, SIREN 985 034 008, RCS Nanterre, siège social à Neuilly-sur-Seine et établissement à La Réunion.",
    "https://www.mobicarpro.re/mentions-legales"
  );

  return (
    <LegalLayout title="Mentions légales">
      <p className="text-sm text-foreground-600 mb-8">
        Dernière mise à jour : septembre 2026
      </p>

      <section className="mb-10">
        <h2 className="font-heading text-2xl tracking-wide text-foreground-900 mb-4">
          Éditeur du site
        </h2>
        <div className="rounded-lg border border-background-200 bg-background-50 px-5 py-2">
          <dl>
            <InfoRow label="Dénomination sociale" value="MOBICAR PRO" />
            <InfoRow label="Forme juridique" value="SASU" />
            <InfoRow label="Capital social" value="1 000 €" />
            <InfoRow label="SIREN" value="985 034 008" />
            <InfoRow label="RCS" value="985 034 008 R.C.S. Nanterre" />
            <InfoRow
              label="N° TVA intracommunautaire"
              value="FR 43 985 034 008"
            />
            <InfoRow
              label="Siège social"
              value="99 avenue Achille Peretti, 92200 Neuilly-sur-Seine"
            />
            <InfoRow label="Président" value="Jérôme Lefevre" />
          </dl>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-2xl tracking-wide text-foreground-900 mb-4">
          Établissement exploité
        </h2>
        <div className="rounded-lg border border-background-200 bg-background-50 px-5 py-2">
          <dl>
            <InfoRow
              label="Établissement de La Réunion"
              value="10 rue des Rubis, Plaine des Cafres, 97418 Le Tampon"
            />
            <InfoRow label="SIRET" value="985 034 008 00039" />
            <InfoRow
              label="Activité"
              value="Entretien et réparation de véhicules automobiles légers"
            />
          </dl>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-2xl tracking-wide text-foreground-900 mb-4">
          Directeur de la publication
        </h2>
        <p className="text-sm text-foreground-700">
          Jérôme Lefevre, Président de MOBICAR PRO.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-2xl tracking-wide text-foreground-900 mb-4">
          Contact
        </h2>
        <div className="rounded-lg border border-background-200 bg-background-50 px-5 py-2">
          <dl>
            <InfoRow label="Téléphone" value="06 93 03 52 38" />
            <InfoRow label="Email" value="contact@mobicar.pro" />
          </dl>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-2xl tracking-wide text-foreground-900 mb-4">
          Hébergement
        </h2>
        <p className="text-sm text-foreground-700">
          Le site est hébergé par la plateforme LWS – Ligne Web Services SAS, 10 rue Penthièvre, 75008 Paris, France.
        </p>
      </section>

      <section>
        <h2 className="font-heading text-2xl tracking-wide text-foreground-900 mb-4">
          Propriété intellectuelle
        </h2>
        <p className="text-sm text-foreground-700 leading-relaxed">
          L&apos;ensemble des éléments du site (textes, images, logos, graphismes)
          est protégé par le droit de la propriété intellectuelle et demeure la
          propriété exclusive de MOBICAR PRO. Toute reproduction, représentation
          ou diffusion, totale ou partielle, sans autorisation préalable écrite
          est interdite et constituerait une contrefaçon.
        </p>
      </section>
    </LegalLayout>
  );
}